// extracted by mini-css-extract-plugin
export default {"carousel":"HardwareFirstAppCarousel_carousel__ZukBX","image":"HardwareFirstAppCarousel_image__8+IwA"};